import { FEAT_FLAGS } from '../../reducers/ThemeOptions';
import serviceTokenNew from '../../services/requestTokenNew';
const API_URL = process.env.REACT_APP_API_URL_DSZ;

/**
 * @description Fetches data within a specified date range and status, with pagination support.
 *
 * @param {string} start_date - The start date for the data range.
 * @param {string} end_date - The end date for the data range.
 * @param {number} limit - The maximum number of items to fetch per page.
 * @param {number} page_no - The page number to retrieve.
 * @param {string} status - The status of the data to fetch.
 * @returns {Promise} - A Promise that resolves to the fetched data.
 *
 * @throws {Error} - Throws an error if the request encounters a problem or returns an error status.
 */
export const getOrderListApi = (params) => {
  return serviceTokenNew({
    url: `${API_URL}rp/orders`,
    method: 'get',
    params: params
  });
};

/**
 * @description Get the total of different order statuses
 */
export const getOrderFiguresApi = () => {
  return serviceTokenNew({
    url: `${API_URL}rp/orders/figures`,
    method: 'get'
  });
};

/**
 * @description Get order detail
 *
 * @param {string} order_id - comma separated order_id
 */
export const getOrderDetailApi = (params) => {
  const shippingFlag = 'true'; // localStorage.getItem(FEAT_FLAGS.SHIPPING.cacheKey);
  if (shippingFlag === 'true') {
    params.shippingFlag = true;
  }
  return serviceTokenNew({
    url: `${API_URL}rp/orders/`,
    method: 'get',
    params: params
  });
};

/**
 * @description Get archive_orders
 * @param page_no
 * @param limit When querying all, set limit:all
 * @param end_date
 */
export const getArchiveOrdersApi = (params) => {
  return serviceTokenNew({
    url: `${API_URL}rp/archive_orders`,
    method: 'get',
    params: params
  });
};

/**
 * @description billing address display
 */
export const getAccountDetailsApi = () => {
  return serviceTokenNew({
    url: `${API_URL}rp/account_details`,
    method: 'get'
  });
};

/**
 * @description cancel order
 */
export const cancelOrderApi = (ids) => {
  return serviceTokenNew({
    url: `${API_URL}rp/orders/cancel?ruo_ids=${ids}`,
    method: 'put',
  })
}